var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"status-card",style:({ background: _vm.bgColor })},[_c('h1',{staticClass:"status-text",style:({ color: _vm.textColor })},[_vm._v(_vm._s(_vm._f("upperCase")(_vm.text)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }